// Utilitário para gerenciar links curtos de apresentações
export interface PresentationData {
  nome: string;
  escritorio: string;
  contato: string;
  precoPix: string;
  precoParcelado: string;
  parcelas: string;
  mensalidade: string;
  createdAt: number;
}

// Gera um código único de 6 caracteres
export function generateShortCode(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// Salva os dados da apresentação e retorna o código
export function savePresentationData(data: PresentationData): string {
  const code = generateShortCode();
  const key = `presentation_${code}`;
  
  // Adiciona timestamp de criação
  const dataWithTimestamp = {
    ...data,
    createdAt: Date.now()
  };
  
  localStorage.setItem(key, JSON.stringify(dataWithTimestamp));
  return code;
}

// Recupera os dados da apresentação pelo código
export function getPresentationData(code: string): PresentationData | null {
  const key = `presentation_${code}`;
  const data = localStorage.getItem(key);
  
  if (!data) {
    return null;
  }
  
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error('Erro ao recuperar dados da apresentação:', error);
    return null;
  }
}

// Gera o link curto
export function generateShortLink(code: string): string {
  const baseUrl = window.location.origin;
  return `${baseUrl}/apresentacao/${code}`;
}

// Valida se o código existe
export function isValidCode(code: string): boolean {
  return getPresentationData(code) !== null;
}
